import Vue from 'vue/dist/vue.js';
import toggleFavorites from './globalFunctions/toggleFavorites';

window.Vue = Vue;
window.CURRENT_SITE_ID = document.querySelector('[name="site_id"]').content;
window.toggleFavorites = toggleFavorites;